import { Component } from '@theme/component';

/** @typedef {typeof globalThis} Window */

/**
 * A component that handles title truncation with responsive behavior
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} [text] - The text element to truncate (optional)
 *
 * @extends {Component<Refs>}
 */
class ProductTitle extends Component {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.#initializeTruncation();
  }

  /**
   * Initialize the title truncation
   */
  #initializeTruncation() {
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.#calculateTruncation();
      });

      this.resizeObserver.observe(this);
      this.#calculateTruncation();
    } else {
      /** @type {Window} */
      (window).addEventListener('resize', this.#handleResize.bind(this));
      this.#calculateTruncation();
    }
  }

  /**
   * Calculate truncation for the title
   */
 #calculateTruncation() {
  /** @type {HTMLElement} */
  const textElement = this.refs.text || this.querySelector('.title-text') || this;

  if (!textElement || !textElement.textContent) return;

  /* Daily Form: Produkttitel niemals abschneiden */
  this.style.height = 'auto';
  this.style.maxHeight = 'none';
  this.style.overflow = 'visible';

  textElement.style.display = 'block';
  textElement.style.height = 'auto';
  textElement.style.maxHeight = 'none';
  textElement.style.overflow = 'visible';
  textElement.style.textOverflow = 'unset';
  textElement.style.whiteSpace = 'normal';
  textElement.style.webkitLineClamp = 'unset';
  textElement.style.webkitBoxOrient = 'unset';
}

  /**
   * Handle window resize events
   */
  #handleResize() {
    this.#calculateTruncation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener('resize', this.#handleResize);
  }
}

if (!customElements.get('product-title')) {
  customElements.define('product-title', ProductTitle);
}

export default ProductTitle;
